/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, FlexRow, FlexCol } from 'sarsaparilla';
import TripDestinationSearchInput from './TripDestinationSearchInput';

const propTypes = {
    destination: PropTypes.object,
    destinationIndex: PropTypes.number,
    trip: PropTypes.object,
    onDelete: PropTypes.func,
    onMove: PropTypes.func,
    onChange: PropTypes.func,
    showErrors: PropTypes.bool,
};

export default class TripDestinationItem extends React.Component {
    static propTypes = propTypes;

    constructor(props) {
        super(props);
        this.moveDownItem = this.moveDownItem.bind(this);
        this.moveUpItem = this.moveUpItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.changeDays = this.changeDays.bind(this);
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
    }

    onSearchInputChange(destination, destinationIndex) {
        if (this.props.onChange) {
            this.props.onChange(destination, destinationIndex);
        }
    }

    moveDownItem() {
        if (this.props.onMove) {
            this.props.onMove(
                this.props.destinationIndex,
                this.props.destinationIndex + 1
            );
        }
    }

    moveUpItem() {
        if (this.props.onMove) {
            this.props.onMove(
                this.props.destinationIndex,
                this.props.destinationIndex - 1
            );
        }
    }

    changeDays(event) {
        this.props.destination.duration = Number(event.target.value);
        if (this.props.onChange) {
            this.props.onChange(this.props.destination, this.props.destinationIndex);
        }
    }

    deleteItem() {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.destinationIndex);
        }
    }

    renderDays() {
        return (
            <div className="rec-form-item-wrap">
                <label
                    htmlFor={`num_days_${this.props.destinationIndex}`}
                    className="rec-sr-only"
                >
                    Choose number of days to stay at this destination
                </label>
                <select
                    id={`num_days_${this.props.destinationIndex}`}
                    onChange={this.changeDays}
                    value={this.props.destination.duration}
                >
                    <option value="1">1 day</option>
                    <option value="2">2 days</option>
                    <option value="3">3 days</option>
                    <option value="4">4 days</option>
                    <option value="5">5 days</option>
                    <option value="6">6 days</option>
                    <option value="7">7 days</option>
                    <option value="8">8 days</option>
                    <option value="9">9 days</option>
                    <option value="10">10 days</option>
                    <option value="12">12 days</option>
                    <option value="13">13 days</option>
                    <option value="14">14 days</option>
                    <option value="15">15 days</option>
                </select>
            </div>
        );
    }

    render() {
        const moveUpEnabled = this.props.destinationIndex > 1;
        const moveDownEnabled =
            this.props.destinationIndex < this.props.trip.destinations.length - 1;

        return (
            <FlexRow
                className="trip-planner-destination-item"
                data-testid="trip-planner-destination-item"
            >
                <FlexCol md={6} className="trip-planner-destination-location">
                    <div className="rec-form-item-wrap">
                        <TripDestinationSearchInput
                            placeholder={
                                this.props.destinationIndex === 0
                                    ? 'Enter Starting Location'
                                    : 'Enter Destination Name'
                            }
                            destination={this.props.destination}
                            destinationIndex={this.props.destinationIndex}
                            validate
                            onChange={this.onSearchInputChange}
                            showErrors={this.props.showErrors}
                        />
                    </div>
                </FlexCol>

                <FlexCol md={4} className="trip-planner-destination-starting">
                    <div className="rec-form-item-wrap">
                        {this.props.destinationIndex === 0 && (
                            <p>
                                <i>Starting Location</i>
                            </p>
                        )}

                        {this.props.destinationIndex > 0 && this.renderDays()}
                    </div>
                </FlexCol>

                {this.props.destinationIndex > 0 && (
                    <FlexCol
                        xs={6}
                        xsOffset={3}
                        md={2}
                        mdOffset={0}
                        className="trip-planner-destination-actions"
                    >
                        <button
                            type="button"
                            disabled={!moveDownEnabled}
                            onClick={this.moveDownItem}
                        >
                            <span className="rec-sr-only">Move destination down</span>
                            <Icon iconName="arrow-bottom" />
                        </button>
                        <button
                            type="button"
                            disabled={!moveUpEnabled}
                            onClick={this.moveUpItem}
                        >
                            <span className="rec-sr-only">Move destination up</span>
                            <Icon iconName="arrow-top" />
                        </button>
                        <button type="button" onClick={this.deleteItem}>
                            <span className="rec-sr-only">delete destination</span>
                            <Icon iconName="close" />
                        </button>
                    </FlexCol>
                )}
            </FlexRow>
        );
    }
}
